import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=47c58b9c"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c58b9c')) {
      api.createRecord('47c58b9c', component.options)
    } else {
      api.reload('47c58b9c', component.options)
    }
    module.hot.accept("./Default.vue?vue&type=template&id=47c58b9c", function () {
      api.rerender('47c58b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template/Default.vue"
export default component.exports